var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex p-2 table-responsive-md" },
        [
          _c("vacation-confirm-awaiting-widget"),
          _c("vacation-approved-widget", { staticClass: "ml-4" }),
          _c("employee-vacation-day-widget", { staticClass: "ml-4" }),
          _vm.activeHoursPack
            ? _c("hour-balance-widget", { staticClass: "ml-4" })
            : _vm._e(),
        ],
        1
      ),
      _c("info-component", {
        staticClass: "mt-5",
        attrs: {
          type: _vm.infoType,
          message: _vm.$t("pages.permission.vacations.info_message"),
        },
      }),
      _c("div", { staticClass: "row mt-5" }, [
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-7" },
          [_c("vacation-calendar-component")],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-5" },
          [
            _vm.vacationCreate
              ? _c("vacation-create-form-component")
              : _vm._e(),
            _vm.vacationEdit
              ? _c("vacation-edit-form-component", {
                  attrs: { vacation: _vm.vacation },
                })
              : _vm._e(),
            _c("vacation-show-modal"),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }